module.exports = new __parcel__URL__("searchError.f24f82b3.svg").toString();